import { API_PATH } from 'common/constants/services';
import useQuery from 'hook/useQuery';
import { SETTLEMENTS_STATUS } from 'model/Settlements';
import React, { useEffect, useState } from 'react';

interface Props {
  year: number;
  month: number;
  coachId: number;
  challengeId: number;
}

export interface Root {
  id: number;
  coach_user: CoachUser;
  challenge: Challenge;
  settlement_date: string;
  net_amount: number;
  raw_amount: number;
  fee_amount: number;
  fee_rate: number;
  settled_at: any;
  account: any;
  base_year_month: string;
  status: SETTLEMENTS_STATUS;
}

export interface CoachUser {
  id: number;
  email: string;
  nickname: string;
}

export interface Challenge {
  id: number;
  name: string;
  description: string;
  purpose: string;
  total_date: number;
  author: string;
  youtube_id: any;
  thumbnail_image: any;
  writer: number;
  activated: boolean;
  is_private: boolean;
  protein_price: number;
}

export interface SaleList {
  items: Item[];
  count: number;
}

export interface Item {
  id: number;
  consumed_proteins: number;
  purchased_at: string;
  raw_amount: number;
  user: User;
}

export interface User {
  nickname: string;
  user: number;
  avatar_url: string;
  email: string;
}

export default function useSettlementDetail({
  year,
  month,
  coachId,
  challengeId,
}: Props) {
  const query = useQuery<Root>(
    API_PATH.COACHES_SETTLEMENTS_CHALLENGES_DETAIL(challengeId),
    {
      year,
      month,
      coach_user_id: coachId,
    },
  );
  const saleQuery = useQuery<SaleList>(
    API_PATH.COACHES_SETTLEMENTS_CHALLENGES_DETAIL_SALE(challengeId),
    {
      year,
      month,
      coach_user_id: coachId,
    },
  );

  return {
    data: query.getQuery.data?.data,
    sales: saleQuery.getQuery.data?.data,
  };
}
